<div mat-dialog-title class="toolbar toolbar-row">
  <span>{{'DEVICE.CONFIG_PROFILE.SET_NAME_TITLE' | translate}}</span>
</div>
<div mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field class="full-width">
      <mat-label>{{'DEVICE.CONFIG_PROFILE.SET_NAME' | translate}}</mat-label>
      <input matInput type="text" formControlName="name" cdkFocusInitial>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>{{'DEVICE.CONFIG_PROFILE.COPY_PROFILE'|translate}}</mat-label>
      <mat-select formControlName="copyFrom" name="copyFrom" class="full-width">
        <mat-option>{{'DEVICE.CONFIG_PROFILE.DO_NOT_COPY'|translate}}</mat-option>
        @for (profile of availablesProfiles; track profile) {
          <mat-option [value]="profile.id">
            {{ profile.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()">{{'COMMON.CANCEL' | translate}}</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">{{'COMMON.CONFIRM' |
  translate}}</button>
</div>